import { useCallback, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type PasswordType = {
  id?: 'password' | 'passwordReInput'
  label?: string
  require?: boolean
  minLength?: number
  validate: Record<string, (value: string) => boolean | string>
  placeholder?: string
}

const Password = (props: PasswordType) => {
  const { t } = useTranslation()
  const {
    id = 'password',
    label = t('login.password'),
    require = true,
    minLength = 8,
    validate,
    placeholder = '',
  } = props

  const {
    register,
    formState: { errors },
  } = useFormContext()

  const [typeState, setTypeState] = useState<'password' | 'text'>('password')

  const togglePasswordShow = useCallback(() => {
    if (typeState === 'password') {
      setTypeState('text')
    } else {
      setTypeState('password')
    }
  }, [typeState])

  return (
    <div className="relative">
      <label htmlFor={`${id}`} className="text-gray-600 mt-3 block text-sm font-bold">
        {label}
        {require ? '*' : ''}
      </label>
      <div className="relative">
        <input
          aria-label={label}
          id={`${id}`}
          type={typeState}
          name={`${id}`}
          placeholder={placeholder}
          autoComplete={`${id}`}
          className="c-input c-placeholder_text-size"
          {...register(`${id}`, {
            // pattern,
            validate: validate,
            minLength,
            required: true,
          })}
        />
        <div
          className="absolute top-[50%] right-[10px] h-[16px] w-[20px] -translate-y-2/4 "
          onClick={() => {
            togglePasswordShow()
          }}
        >
          {typeState === 'password' ? (
            <img src={`${process.env.NEXT_PUBLIC_SITEURL}/images/common/icon/eye-slash-solid.svg`} alt="" />
          ) : (
            <img src={`${process.env.NEXT_PUBLIC_SITEURL}/images/common/icon/eye-solid.svg`} alt="" />
          )}
        </div>
      </div>

      {id === 'password' && (
        <>
          <p className="text-xs text-color01">{t('login.password_notification', { passwordCharacters: minLength })}</p>
          {errors.password?.type === 'e' && typeof errors.password.message === 'string' && (
            <p className="error text-xs text-color01">{errors.password?.message}</p>
          )}
          {errors.password?.type === 'p' && typeof errors.password.message === 'string' && (
            <p className="error text-xs text-color01">{errors.password?.message}</p>
          )}
          {errors.password?.type === 'minLength' && (
            <p className="error text-xs text-color01">
              {t('login.password_error_message_8_length', { passwordCharacters: minLength })}
            </p>
          )}
          {errors.password?.type === 'required' && (
            <p className="error text-xs text-color01">{t('login.password_error_message_input_required')}</p>
          )}
        </>
      )}

      {id === 'passwordReInput' && (
        <>
          {errors.passwordReInput?.type === 'confirm' && typeof errors.passwordReInput.message === 'string' && (
            <p className="error text-xss text-color01">{errors.passwordReInput.message}</p>
          )}
        </>
      )}
    </div>
  )
}

export default Password
